import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import StarRateIcon from '@material-ui/icons/Star';
import { vsprintf } from 'sprintf-js';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  priceTitle: {
    color: '#313330',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.2,
    paddingTop: 3,
    textAlign: 'center',
  },
  paper: {
    minHeight: 58,
    width: 100,
  },
  paperPrice: {
    minHeight: 58,
    width: 100,
    position: 'relative',
  },
  pricingValue: {
    alignItems: 'center',
    display: 'flex',
    fontFamily: 'Lato, Arial, sans-serif',
    fontSize: 15,
    fontWeight: 700,
    justifyContent: 'center',
    lineHeight: 1,
    minHeight: 28,
    paddingTop: 4,
    textAlign: 'center',
    '& svg': {
      fontSize: 20,
      marginRight: 2,
    },
  },
  scoreValue: {
    '& span': {
      position: 'relative',
      top: 1,
    },
  },
  control: {
    padding: theme.spacing(2),
  },
  sizePaper: {
    width: 150,
  },
  '@media (min-width: 1024px)': {
    paper: {
      width: 100,
    },
  },
});

const hebrewLables = {
  additionalTitle: 'מידע נוסף',
  additionalDefault: 'מצויין בעיר',
  editorScore: 'ציון',
  price: 'מחיר',
};

class ResultItemPriceRow extends React.Component {
  state = {
    spacing: '1',
  };

  render() {
    const { classes, data, hideExtraField = false } = this.props;
    const { spacing } = this.state;

    const {
      price,
      score,
      tireType = hebrewLables.additionalDefault,
    } = data;

    const hasScore =
      score != null && score !== '' && !Number.isNaN(Number(score));

    return (
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={Number(spacing)}>
            {!hideExtraField && (
              <Grid key="editor_score" item className={classes.extraInfoGrid}>
                <Paper className={classes.paper}>
                  <Typography
                    className={classes.priceTitle}
                    component="div"
                  >
                    {hebrewLables.additionalTitle}
                  </Typography>
                  <div className={classes.pricingValue}>
                    {tireType}
                  </div>
                </Paper>
              </Grid>
            )}
            <Grid key="price" item>
              <Paper className={classes.paperPrice}>
                <Typography
                  className={classes.priceTitle}
                  component="div"
                >
                  מחיר
                </Typography>
                <div className={classes.pricingValue}>
                  {vsprintf('%.2f', [price])} ₪
                </div>
              </Paper>
            </Grid>
            {hasScore && (
              <Grid key="customer_score" item>
                <Paper className={classes.paper}>
                  <Typography
                    className={classes.priceTitle}
                    component="div"
                  >
                    {hebrewLables.editorScore}
                  </Typography>
                  <div
                    className={`${classes.pricingValue} ${classes.scoreValue}`}
                  >
                    <span>{score}</span> <StarRateIcon />
                  </div>
                </Paper>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

ResultItemPriceRow.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  hideExtraField: PropTypes.bool,
};

export default withStyles(styles)(ResultItemPriceRow);
